'use strict';

function createAction(type, data) {
	return {
		type: type,
		data: data
	};
}

module.exports = {

	// This is a special action type used by ShapewaysModel.js
	// which allows a model to register a method to listen to all
	// action types
	ALL: {
		type: 'ALL',
		createAction: createAction
	}

};
